<template>
	<div>
		<div class="news-title" :style="{fontSize: details.titleSize ? details.titleSize : '18px'}">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				{{details.title}}
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="inner-content">
			<div v-html="details.txt">

			</div>
			<div class="back" @click="$router.back(-1)">
				返回列表
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				newsId: "",
				details: {

				}
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_1.png'
			that.newsId = this.$route.query.news_id
			that.getNewsDetails()
		},
		methods: {
			getNewsDetails() {
				let that = this
				that.$http.post({
					url: '/api/content/getContentById',
					data: {
						id: that.newsId
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.details = res.data
					}
				})
			},
			backToList() {
				this.router.back(-1)
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		width: 1000px;
		margin: 10px auto;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/news/yjdt_xqy.vue